import { hasForegroundOrderForm } from '@/lib/order-form-guard'
import { message } from 'antd'
import { create } from 'zustand'
import { orderRoleFromPath, type OrderDetailMode } from '@/lib/order-role-context'

/**
 * 全局订单详情弹窗状态:任务处理过程中「查看订单详情」以大号模态盖在当前页上,
 * 不跳转页面(避免任务上下文被隐藏、给人业务中断感)。任何组件调 open(orderId) 即可。
 */
interface OrderDetailModalState {
  orderId: string | null
  sourceUrl: string | null
  role?: string
  mode: OrderDetailMode
  open: (orderId: string, options?: { sourceUrl?: string; role?: string; mode?: OrderDetailMode }) => void
  close: () => void
}

export const useOrderDetailModal = create<OrderDetailModalState>((set) => ({
  orderId: null,
  sourceUrl: null,
  mode: 'staff',
  open: (orderId, options) => {
    if (hasForegroundOrderForm()) { message.info('请先完成或关闭当前办理表单'); return }
    const sourceUrl = options?.sourceUrl || window.location.pathname + window.location.search + window.location.hash
    const role = options?.role || orderRoleFromPath(new URL(sourceUrl, window.location.origin).pathname)
    set({ orderId, sourceUrl, role, mode: options?.mode || (role === 'CUSTOMER' ? 'customer' : 'staff') })
  },
  close: () => set({ orderId: null, sourceUrl: null, role: undefined, mode: 'staff' }),
}))
